module.exports = __webpack_public_path__ + "img/help-ct8.dfc284b1.png";